<div class="website-column-cell-container {{customClass}}">
  <app-brand-favicon [domain]="domain"></app-brand-favicon>
  <a class="website-column-cell" [href]="'//'+domain" [title]="domain" target="_blank">{{ domain }}</a>
</div>
